import { Component, OnInit, Inject } from '@angular/core';
import {
  BusinessLogicRequirements,
  BusinessRequirementsInjectionToken,
} from '../../../business-logic.requirements';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/lib/auth.service';

@Component({
  selector: 'app-clever-login',
  templateUrl: './clever-login.component.html',
  styleUrls: ['./clever-login.component.css'],
})
export class CleverLoginComponent implements OnInit {
  constructor(
    @Inject(BusinessRequirementsInjectionToken)
    private business: BusinessLogicRequirements,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      console.log(params);
      this.cleverLogin(params['code']);
    });
  }
  public dashboardRedir: any;
  public feedbackTitle = '';
  public feedbackBody = '';
  public feedbackBtn = {
    status: false,
    text: '',
  };
  public tickIcon = true;
  public showFeedback = false;

  cleverLogin(code) {
    var body = {
      code: code,
      redirect_uri: window.origin + '/clever/redirect',
    };
    this.business.cleverLogin(body).subscribe(
      (data) => {
        console.log('data', data);
        var header = {
          apikey: data.ApiKey,
          username: data.username,
          user: data.userId,
          password: data.Token,
          playerid: data.idPlayer,
        };
        this.dashboardRedir = this.authService.getRedirectDashboardUrl(header);
        window.location.replace(this.dashboardRedir);
      },
      (err) => {
        console.log('err', err);
        if (err.error.message == 'invalid code') {
          this.feedbackTitle = err.error.message;
          this.feedbackBody = '';
          this.feedbackBtn = {
            status: false,
            text: '',
          };
          this.tickIcon = false;
          this.showFeedback = true;
          setTimeout(() => {
            this.showFeedback = false;
            // this.Bundle = false;
            this.router.navigate(['']);
          }, 3000);
        }
      }
    );
  }
}
